import formSubmit from '../modules/formSubmit';
import isValidEmail from '../functions/isValidEmail';
import { querySelectorId } from '../functions/querySelectors';
import { FORM_ROW_CLASS, FORM_ROW_ERROR_CLASS, BEFORE_SUBMIT_EVENT } from '../config/main';
import successProcess from '../functions/successProcess';
import { CSRF_TOKEN_ATTR } from '../functions/xhrLoad';

const NEWSLETTER_FORM_ID = 'planner-box-form';
const EMAIL_ID = 'subscribeEmail';
const AGREE_ID = 'subscribeTerm';

let formSuccess = function(event) {
  successProcess(this);
};

let beforeSubmit = function(event) {
  let email = querySelectorId(EMAIL_ID);
  let agree = querySelectorId(AGREE_ID);

  let agreeWrap = agree.closest(`.${FORM_ROW_CLASS}`);
  let emailWrap = email.closest(`.${FORM_ROW_CLASS}`);

  emailWrap.classList.remove(FORM_ROW_ERROR_CLASS);
  agreeWrap.classList.remove(FORM_ROW_ERROR_CLASS);

  if (email && email.value && isValidEmail(email.value) && agree && agree.checked) {
    let csrf = document.createElement('input');
    csrf.setAttribute('type', 'hidden');
    csrf.setAttribute('name', '_csrfToken');
    csrf.value = document.body.getAttribute(CSRF_TOKEN_ATTR);
    this.appendChild(csrf);

    let method = document.createElement('input');
    method.setAttribute('type', 'hidden');
    method.setAttribute('name', '_method');
    method.value = 'POST';
    this.appendChild(method);

    return;
  }

  event.preventDefault();
  event.stopPropagation();

  if (!(email && email.value && isValidEmail(email.value)) && emailWrap) {
    emailWrap.classList.add(FORM_ROW_ERROR_CLASS);
  }

  if (!(agree && agree.checked) && agreeWrap) {
    agreeWrap.classList.add(FORM_ROW_ERROR_CLASS);
  }
};

export function ajaxForm() {
  let form = querySelectorId(NEWSLETTER_FORM_ID);

  if (form) {
    formSubmit(form);
    form.addEventListener('formSuccess', formSuccess);
    form.addEventListener(BEFORE_SUBMIT_EVENT, beforeSubmit);
  }
}
